import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
// import { Editor } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { GlobalToolbarConfig, Options } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';

@Component({
  selector: 'app-items-survey-like-dislike',
  templateUrl: './items-survey-like-dislike.component.html',
  styleUrls: ['./items-survey-like-dislike.component.scss']
})
export class ItemsSurveyLikeDislikeComponent implements OnInit {
  toolbar = GlobalToolbarConfig;
  isCkeditorLoading: boolean = true;
  public uploadedFileNames = [];
  public uploadedFileOptions = [];
  addedOptions: Options[] = [
    {
      answerDescription: { description: 'TRUE', mediaURL: [''], file_name: this.uploadedFileOptions },
      answerValid: false,
      arrangeOrder: 0,
      correctPoints: 0,
      modified: false,
      optionId: 1,
      selected: false,
      styleid: 0
    },
    {
      answerDescription: { description: 'FALSE', mediaURL: [''], file_name: this.uploadedFileOptions },
      answerValid: false,
      arrangeOrder: 0,
      correctPoints: 0,
      modified: false,
      optionId: 2,
      selected: false,
      styleid: 0
    },
  ];

  // @ViewChild(QuestionListComponent) child !: any;
  @Output() postCreated = new EventEmitter();
  surveyLikeDislikeForm: FormGroup;
  itemId: any;
  listDisplay = false;
  display: boolean = false;
  updateOptionText: any;
  dialogResult: any;
  questionId: string;
  // questionEditor: Editor = new Editor();
  // editor: Editor = new Editor();
  isEditMode: boolean = false;
  isListMode: boolean = false;
  getQuestionDisplay: string;
  addOptionEditor = false;
  saveDisable: boolean = false;
  ckeditorConfig = CkeditorConfig;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    correctPoints: 'correctPoints',
    maximumcharacterForFreetext: 'maximumcharacterForFreetext',
    itemId: 'itemId',
    options: 'options',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch',
    queOrientation: 'queOrientation',
  };
  QuestionOrientation: any;
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  errorMessage;
  QuestionImages = []
  imageId: number = 1;
  constructor(private formBuilder: FormBuilder, private notificationService: NotificationService,
    public questionService: QuestionService, public itemservice: ItemService,
    private routerstate: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,private webErrorService: WebErrorService,public translate: TranslateService,) {
    this.routerstate?.parent?.params?.subscribe((data) => { this.itemId = data.id; });

    this.questionId = sessionStorage.getItem(this.reuseProp.questionuuId);
    if (!this.questionId) { this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId; }

    this.surveyLikeDislikeForm = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.SurveyLikeDislike),
      questionTypeId: new FormControl(QuestionTypeIdEnum.SurveyLikeDislike),
      questiondisplayoptions: new FormControl('Vertical'),
      active: new FormControl(true),
      autoScoring: new FormControl(false),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl('true'),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl('', Validators.required), mediaURL: new FormControl([""]), file_name: new FormControl([""]) }),
      [this.reuseProp.itemId]: new FormControl(''),
      [this.reuseProp.options]: new FormArray([], Validators.required),
      [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0),
    });

    this.addedOptions.forEach((element) => {
      (<FormArray>this.surveyLikeDislikeForm.controls[this.reuseProp.options]).push(new FormControl(element));
    });

    this.questionService.getQuestionOrientation().subscribe(o => {this.QuestionOrientation = o.data})
  }

  get f() {
    return this.surveyLikeDislikeForm.controls;
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  ngOnInit(): void {
    // this.questionEditor = new Editor();
    if (this.questionId) {
      this.isEditMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.questionId)
        .subscribe((resdata) => {
          this.surveyLikeDislikeForm.patchValue(resdata.data);
          this.surveyLikeDislikeForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.stringify(resdata.data.scoringTypeExactMatch));
          questionServiceGetSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
  }

  back() {
    this.postCreated.emit('false');
    this.display = true;
    // this.editor.destroy();
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  saveQuestion() {
    this.surveyLikeDislikeForm.controls[this.reuseProp.itemId].setValue(sessionStorage.getItem(this.reuseProp.itemId));
    let question = this.surveyLikeDislikeForm.value.questiondescription['description'];
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();;

    this.surveyLikeDislikeForm.value.questiondescription['file_name'] = this.uploadedFileNames;
    if (question1.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
      return;  // Used to display alert message
    }
    this.surveyLikeDislikeForm.value.questiondescription['description'] = question1;
    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.surveyLikeDislikeForm.value.questiondescription['description'] = question1;
    this.surveyLikeDislikeForm.value.questionImages = this.QuestionImages;

    if (this.isEditMode) {
      const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.surveyLikeDislikeForm.value, this.itemId, this.questionId).subscribe(
        (resData) => {
          this.itemservice.editedGetItem(resData.data);
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isListMode = true;
          questionServiceUpdateSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
    else {
      const questionServicePostSubscription: Subscription = this.questionService.addQuestion(this.surveyLikeDislikeForm.value, this.itemId).subscribe(
        (resData) => {
          this.isEditMode = true;
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isEditMode = true;
          this.isListMode = true;
          questionServicePostSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
  }
}
